import { decamelizeKeys } from "humps";
import api from "PFCore/api";
import { decamelizeDesiredKeys } from "PFCore/helpers/keys_camelization_utils";
import { Activity, Id, PaginatedCollection, QueryParams } from "PFTypes";

export type InternalExperienceResponseData = {
  id: Id;
  activity: Activity;
};

export type InternalExperiencesResponse = PaginatedCollection<InternalExperienceResponseData[]>;

export type FetchInternalExperiencesParams = QueryParams & {
  profileId: Id | Id[];
  page?: number;
  perPage?: number;
};

export const fetchInternalExperiences = (
  params: FetchInternalExperiencesParams
): Promise<InternalExperiencesResponse> =>
  api({
    url: "internal_experiences",
    method: "GET",
    params
  }).then((res) => decamelizeDesiredKeys<InternalExperiencesResponse>(res, ["entries"])); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized

export const fetchInternalExperience = (internalExperienceId: Id): Promise<Activity> =>
  api({
    url: `internal_experiences/${internalExperienceId}`,
    method: "GET"
  }).then((res) => decamelizeKeys(res) as Activity); // TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
